import { styled } from '@mui/material/styles';
import { Paper } from '@mui/material';

export const MetricCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: 'center',
  background: 'linear-gradient(135deg, #232536 0%, #374151 100%)',
  color: 'white',
  borderRadius: theme.spacing(2),
  position: 'relative',
  overflow: 'hidden',
  height: '164px',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.75),
    height: '158px',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100px',
    height: '100px',
    background:
      'radial-gradient(circle, rgba(255, 207, 81, 0.12) 0%, transparent 70%)',
  },
}));
